import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { BusinessUnitModel } from '@fi-app/business-unit/business-unit.model';
import {
    FiUserEditDataFieldActivation_Settings,
    TFiUserEditDataFieldActivation_Settings,
} from '@fi-app/data-field/data-field-edit/active/active.component';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { AppTextService } from '@fi-shared/app-text';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-business-unit-edit-status',
    templateUrl: './fi-business-unit-edit-status.component.html',
    styleUrls: ['./fi-business-unit-edit-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-edit-status' },
    providers: [
        {
            provide: FiUserEditDataFieldActivation_Settings,
            deps: [FiBusinessUnitEditStatusComponent],
            useFactory: (instance: FiBusinessUnitEditStatusComponent): TFiUserEditDataFieldActivation_Settings => ({
                datePickerLabelStartDate: instance.appTextService.get('common.start_date'),
                datePickerLabelEndDate: instance.appTextService.get('common.end_date'),
                datePickerAppearance: 'outline',
                isItemActivatedDisabled: instance.currentUserHasUnitAsSingle(),
            }),
        },
        { provide: FiComponentsContainer, useExisting: FiBusinessUnitEditStatusComponent },
    ],
    standalone: false,
})
export class FiBusinessUnitEditStatusComponent extends FiComponentsContainer {
    @Input() dataFields: DataFieldModel[];
    @Input() businessUnit: BusinessUnitModel;

    constructor(
        private appTextService: AppTextService,
        private userDataService: FiUserDataService,
    ) {
        super();
    }

    currentUserHasUnitAsSingle() {
        const userToBusinessUnitIds = this.userDataService.getUserBusinessUnits().map((bu) => bu.Id);
        return userToBusinessUnitIds.length === 1 && userToBusinessUnitIds[0] === this.businessUnit.Id;
    }
}
